<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-circle-check"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    :stroke-width="stroke"
    :stroke="color"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <circle cx="12" cy="12" r="9" />
    <path d="M9 12l2 2l4 -4" />
  </svg>
</template>

<script>
export default {
  name: "Checkmark",
  props: {
    color: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    stroke: {
      type: Number,
      required: true,
      default: 1.5,
    },
  },
};
</script>